import { FormRegistrySubmitButton } from '~/shared/forms/FormRegistryModal';
import { Button } from '~/shared/components/buttons/Button';
import { ChevronLeft } from 'lucide-react';
import { useGoalsAndInterventionsWizard } from './GoalsAndInterventionsWizardContext';
import { SelectGoalFooter } from './select-goal/SelectGoalFooter';
import { CapturePredefinedGoalDetailsFooter } from './predefined-goal-details/CapturePredefinedGoalDetailsFooter';
import { SelectingInterventionFooter } from './selecting-interventions/SelectingInterventionFooter';
import { CaptureInterventionDetailsFooter } from './capture-intervention-details/CaptureInterventionDetailsFooter';

export function Footer() {
	const { wizardState, dispatch } = useGoalsAndInterventionsWizard();
	if (wizardState.currentStep === 'SELECT_GOAL' && wizardState.selectedGoalOption === 'custom') {
		return <SelectGoalFooter />;
	}
	if (wizardState.currentStep === 'SELECT_GOAL' || wizardState.currentStep === 'LOAD_GOAL_DEFINITION') {
		return null;
	} else if (!wizardState.selectedGoal) {
		throw new Error('Invalid state');
	} else if (wizardState.currentStep === 'CAPTURE_GOAL_DETAILS') {
		if (wizardState.selectedGoal.type === 'existing' || wizardState.selectedGoal.type === 'custom') {
			throw new Error('Invalid state');
		}
		return <CapturePredefinedGoalDetailsFooter />;
	} else if (wizardState.currentStep === 'LOAD_INTERVENTION_DEFINITIONS') {
		return null;
	} else if (wizardState.currentStep === 'SELECTING_INTERVENTIONS') {
		return <SelectingInterventionFooter />;
	} else if (wizardState.currentStep === 'CAPTURE_INTERVENTION_DETAILS') {
		return <CaptureInterventionDetailsFooter />;
	}

	return (
		<div className="flex items-center gap-2">
			<Button onClick={() => dispatch({ type: 'PREVIOUS_CLICKED' })} Icon={ChevronLeft} label="Previous" />
			<FormRegistrySubmitButton />
		</div>
	);
}
